import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import FeedbackResume from './FeedbackResume';
import FeedbackDetail from './FeedbackDetail';
import api from '../services/apiClient';

import IFeedbackData from '../interfaces/IFeedbackData';
import { useToast } from '../hooks/toast';

const Feedback: React.FC<any> = () => {
  const [dataFeedback, setDataFeedback] = useState<IFeedbackData>(
    {} as IFeedbackData
  );

  const { addToast } = useToast();
  const [searchParams] = useSearchParams();
  const [showDetail, setShowDetail] = useState(false);
  const updateFeedbackNew = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    api.patch('/AvaliacaoAtendimento/new', null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  useEffect(() => {
    updateFeedbackNew();
  }, []);

  useEffect(() => {
    const telaPrincipal = searchParams.get('principal');

    const filtroId =
      searchParams.get('id') === null ? 0 : Number(searchParams.get('id'));

    if (filtroId > 0) {
      const token = localStorage.getItem('@LiveChat:token');

      api
        .get(`/AvaliacaoAtendimento/${filtroId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const { success } = response.data;

          if (success) {
            setDataFeedback(response.data.data);
          } else {
            addToast({
              type: 'error',
              title: 'Erro',
              description: 'Não foi possível carregar os dados',
            });
          }
        })
        .catch((err) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: 'Não foi possível carregar os dados',
          });
        });
    }

    if (telaPrincipal === null) setShowDetail(false);
    else if (telaPrincipal === 'true') setShowDetail(false);
    else setShowDetail(true);
  }, [searchParams]);

  return (
    <div className="h-100 d-flex flex-column">
      <span style={{ fontSize: '2.5rem', fontWeight: '600' }}>Feedback</span>
      {showDetail && dataFeedback.seqAtendimento ? (
        <FeedbackDetail
          dataDetail={dataFeedback}
          setShowDetail={setShowDetail}
        />
      ) : (
        <FeedbackResume
          setDataFeedback={setDataFeedback}
          setShowDetail={setShowDetail}
        />
      )}
    </div>
  );
};

export default Feedback;
